import { createContext } from "react";

export type SidebarData = {
    potentialClientCount: number;
    needs2FASetup: boolean;
};

export const defaultSidebarData: SidebarData = {
    potentialClientCount: 0,
    needs2FASetup: false,
};

export const initialCoachSidebarDataContext = {
    ...defaultSidebarData,
    reloadSidebarData: async () => {},
};

export const CoachSidebarDataContext = createContext(
    initialCoachSidebarDataContext,
);
